// extracted by mini-css-extract-plugin
export default {"content":"Content_content__j5Q7K","content-padding":"Content_content-padding__wTiym"};